<div class="arrow-up" *ngIf="text" [style.left]="marginLeft"></div>
<div class="container" id="customTooltip" *ngIf="text">
  {{ text }}
  <ng-container *ngTemplateOutlet="content"></ng-container>
</div>
